import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import AdminCompanies from "@/components/Companies/AdminCompanies.vue";
import { CompanyService } from "@/services/CompanyService";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCompaniesView',
  async setup(__props, { expose: __expose }) {
  __expose();

let __temp: any, __restore: any

const companyService = new CompanyService();
const companies = ref<any[]>([]);

companies.value = ((
  ([__temp,__restore] = _withAsyncContext(() => companyService.getAll())),
  __temp = await __temp,
  __restore(),
  __temp
)) ?? [];

const __returned__ = { companyService, companies, AdminCompanies, get CompanyService() { return CompanyService }, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})